import { Directive, HostListener, ElementRef, Input, Optional, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CurrencyMaskConfig, DEFAULT_CURRENCY_MASK_CONFIG } from './currency.config';

@Directive({
  selector: '[appCurrencyMask]',
})
export class CurrencyMaskDirective implements OnInit {

  @Input("options") options: Partial<CurrencyMaskConfig> = {};

  private config: CurrencyMaskConfig;
  private rawDigits = "";

  private disabled = false;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() private control: NgControl
  ) {
    this.config = { ...DEFAULT_CURRENCY_MASK_CONFIG };
  }

  ngOnInit() {
    this.config = { ...this.config, ...this.options };
  }

  @HostListener("input", ["$event"])
  onInput() {
    const htmlElement: HTMLInputElement = this.el.nativeElement;
    const cleanInputValue: string = htmlElement.value.replace(/\D/g, "");

    if (!cleanInputValue) {
      this.rawDigits = "";
      htmlElement.value = "";
      this.control?.control?.setValue(null);
      return;
    }

    this.rawDigits = cleanInputValue;
    this.setFormattedValue(this.rawDigits);
  }

  @HostListener("focus")
  onFocus() {
    const currentValue = this.el.nativeElement.value.replace(/\D/g, "");
    if (currentValue) {
      this.setFormattedValue(currentValue);
    }
  }

  private setFormattedValue(digits: string) {
    const numberOfDecimals: number = 2;
    const inputElement: HTMLInputElement = this.el.nativeElement;

    let integerPart: string = digits.slice(0, digits.length - numberOfDecimals);
    let decimalPart: string = digits.slice(digits.length - numberOfDecimals);

    if (!integerPart) integerPart = "0";
    if (decimalPart.length < numberOfDecimals) {
      decimalPart = decimalPart.padStart(numberOfDecimals, "0");
    }

    const parseValueToFloat: number = Number.parseFloat(integerPart + "." + decimalPart);
    this.control?.control?.setValue(parseValueToFloat, { emitEvent: true });
    inputElement.value = parseValueToFloat.toFixed(2);
  }
}
